// AT-only behaviour for the legacy-look popup. Isolated from the shared
// as-pm-0176-recharge.js: only hooks the event bus and drives the existing
// <rb-delivery> toggle + #rb-configuration-selling_plan. AT-only load.
(function () {
  // <rb-modal> is rendered later in the same section, so wait for the DOM.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  function boot() {
  const modal = document.querySelector('rb-modal[lang="at"]');
  if (!modal) return;

  const money = new Intl.NumberFormat(
    `${(window.Shopify && Shopify.locale) || 'de'}-${(window.Shopify && Shopify.country) || 'AT'}`,
    { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }
  );

  const planBtn = modal.querySelector('.pm-0082-setting-plan');
  const uniqueBtn = modal.querySelector('.pm-0082-setting-unique');
  const planPrice = modal.querySelector('.pm-0082-setting-plan-price');
  const uniquePrice = modal.querySelector('.pm-0082-setting-unique-price');
  const freqWrap = modal.querySelector('.pm-0082-setting-frequency');

  const realToggle = () => document.querySelector('#rb-configuration-delivery');
  const realSwitch = () => document.querySelector('rb-delivery .rb-switch');
  const realSelect = () => document.querySelector('#rb-configuration-selling_plan');
  const isSubscribed = () => !!document.querySelector('rb-delivery[active]');

  // Both option prices must show the actually-payable total (incl. the 15%
  // campaign discount), but the core only computes the active mode. So compute
  // each mode here — same per-item math as RechargeAmount.getTotals (per-item
  // tier floor, then campaign-discount floor on the sum), in cents.
  function modeTotal(subscribed) {
    const extra = parseFloat(document.querySelector('script[data-rb-extra-discount]')?.textContent || '0') || 0;
    const tierBtn = document.querySelector('rb-button[active]');
    const tier = tierBtn ? parseInt(tierBtn.getAttribute('percentage'), 10) || 0 : 0;
    const progress = document.querySelector('rb-amount progress');
    const tierActive = !!progress && progress.max > 0 && progress.value >= progress.max && tier > 0;

    let sum = 0, any = false;
    document.querySelectorAll('.rb-item-actions input').forEach(inp => {
      const qty = parseInt(inp.value, 10) || 0;
      if (qty <= 0) return;
      const id = inp.closest('.rb-item')?.getAttribute('data-rb-item-id');
      const meal = id && document.querySelector(`[data-product="${id}"]`);
      const base = meal ? parseInt(meal.dataset.mealPrice, 10) || 0 : 0;
      if (base <= 0) return;
      const unit = subscribed ? (parseInt(meal.dataset.subPrice, 10) || base) : base;
      const lineUnit = tierActive ? unit - Math.floor(unit * tier / 100) : unit;
      sum += lineUnit * qty;
      any = true;
    });
    if (!any) return null;
    return extra > 0 ? sum - Math.floor(sum * extra / 100) : sum;
  }

  function updatePrices() {
    const plan = modeTotal(true);
    const uniq = modeTotal(false);
    if (planPrice && plan != null) planPrice.innerText = money.format(plan / 100);
    if (uniquePrice && uniq != null) uniquePrice.innerText = money.format(uniq / 100);
  }
  document.addEventListener('recharge:progress', updatePrices);

  // --- subscription / one-time switch --------------------------------------
  function setActive(subscribed) {
    if (planBtn) planBtn.classList.toggle('active', subscribed);
    if (uniqueBtn) uniqueBtn.classList.toggle('active', !subscribed);
    if (freqWrap) freqWrap.classList.toggle('active', subscribed);
  }

  function want(subscribed) {
    // flip the real toggle only if it disagrees; it re-syncs us via recharge:delivery
    const cb = realToggle();
    if (cb && cb.checked !== subscribed) {
      (realSwitch() || cb).click();
    }
    setActive(subscribed);
  }

  if (planBtn) planBtn.addEventListener('click', () => want(true));
  if (uniqueBtn) uniqueBtn.addEventListener('click', () => want(false));
  document.addEventListener('recharge:delivery', () => setActive(isSubscribed()));

  // --- frequency select (clone of the real selling-plan select) ------------
  let freqClone = null;
  function mountFrequency() {
    if (!freqWrap || freqClone) return;
    const real = realSelect();
    if (!real) return;

    freqClone = real.cloneNode(true);
    freqClone.removeAttribute('id');

    freqClone.addEventListener('change', () => {
      const r = realSelect();
      if (!r) return;
      r.selectedIndex = freqClone.selectedIndex;
      r.dispatchEvent(new Event('change')); // RechargeDelivery.onSelectChange
    });

    freqWrap.appendChild(freqClone);
    syncFreq();
  }

  // The core resets #rb-configuration-selling_plan (preselect/default) without
  // firing 'change', so pull its current value into the clone on the bus events
  // rather than relying on change — otherwise the clone shows a stale default.
  function syncFreq() {
    const real = realSelect();
    if (freqClone && real) freqClone.selectedIndex = real.selectedIndex;
  }
  document.addEventListener('recharge:progress', syncFreq);
  document.addEventListener('recharge:delivery', syncFreq);

  // --- init -----------------------------------------------------------------
  // <rb-delivery> + its select render after Recharge is ready.
  function init() {
    mountFrequency();
    setActive(isSubscribed());
  }
  document.addEventListener('bundling-widget:ready', () => setTimeout(init, 200));

  // Fallback poll in case bundling-widget:ready already fired before this ran.
  let tries = 0;
  const poll = setInterval(() => {
    if (realSelect() || ++tries > 40) {
      clearInterval(poll);
      init();
    }
  }, 250);
  }
})();
